<template>
  <div>
    <a-row>
      <a-col :span="12">
        <a-descriptions
          title="基本信息"
          :column="1"
          class="simiot-descriptions"
        >
          <a-descriptions-item label="名称">
            {{ cpeSupplier.name }}
          </a-descriptions-item>

          <a-descriptions-item label="联系人">
            {{ cpeSupplier.contact_name }}
          </a-descriptions-item>

          <a-descriptions-item label="联系人电话">
            {{ cpeSupplier.contact_phone }}
          </a-descriptions-item>

          <a-descriptions-item label="CPE总量">
            {{ cpeSupplier.cpe_total_count }}
          </a-descriptions-item>

          <a-descriptions-item label="库存量">
            {{ cpeSupplier.cpe_stock_count }}
          </a-descriptions-item>

          <a-descriptions-item label="备注">
            {{ cpeSupplier.remark }}
          </a-descriptions-item>

          <a-descriptions-item label="创建时间">
            {{ cpeSupplier.created_at }}
          </a-descriptions-item>

          <a-descriptions-item label="更新时间">
            {{ cpeSupplier.updated_at }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findCpeSupplier } from '@/api/cpe_supplier'

export default {
  name: 'ShowCpeSupplier',
  data() {
    return {
      cpeSupplier: {}
    }
  },
  computed: {
    cpeSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      findCpeSupplier(this.cpeSupplierId).then((res) => {
        if (res.code === 0) {
          this.cpeSupplier = res.data
        }
      })
    }
  }
}
</script>
